import type { TrackingEvent } from 'src/types/trackingData';

export const actionTrackError = (tealiumEvent: TrackingEvent) => ({
  type: 'TRACK_ERROR',
  payload: tealiumEvent,
});
